// extracted by mini-css-extract-plugin
export default {"investorItem":"investorItem_investorItem__u9ruW","logo":"investorItem_logo__WEi0M","link":"investorItem_link__jRafx"};